import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';

import { buildBadgeActiveSummary } from './helpers';
import BadgeActive from '../BadgeActive';

/**
 * Displays an active/inactive badge with a formatted time range summary below it.
 * This component combines a BadgeActive component (showing current active/inactive status)
 * with a human-readable time range description.
 * @param {object} props - The component props
 * @param {object} props.active - The active time range object containing start and finish
 *   timestamps.
 * @returns {React.ReactElement} A React fragment containing the BadgeActive component and formatted
 *   time range summary
 */
function BadgeActiveTimeRange({ active }) {
  const { start, finish } = active || {};
  const intl = useIntl();

  return (
    <>
      <BadgeActive start={start} finish={finish} />
      <br />
      {buildBadgeActiveSummary(intl, active)}
    </>
  );
}

BadgeActiveTimeRange.propTypes = {
  active: PropTypes.shape({
    start: PropTypes.number,
    finish: PropTypes.number,
  }).isRequired,
};
export default BadgeActiveTimeRange;
